import React, { useState } from "react";
// import FlexmonsterReact from "react-flexmonster";
import './Reports.less';
// import {Link} from "react-router-dom";
import ReportsList from "../ReportsList";
import { Button, Icon } from "semantic-ui-react";
import NewReportModal from "../NewReportModal";
import { PAGE_ROUTES } from "../../constants";
import { has } from "../../utils/GeneralUtils";
import { useHistory } from 'react-router-dom'
import CampaignDisclosureDateModal from "../CampaignDisclosureDateModal";

function Reports( props ) {

    // console.log( props );

    const [ campaignModalState, setCampaignModalState ] = useState( { 
            showModal: false, 
            selectedReport: null,
        } );
    
        let openCampaignModal = ( report ) => setCampaignModalState( { showModal: true, selectedReport: report } );
        let closeCampaignModal = () => setCampaignModalState( { showModal: false, selectedReport: null } );

    let moduleId;

    if ( has( props, "match.params.moduleId" ) )
        moduleId = props.match.params.moduleId;

    // console.log( "The Module ID is: " + moduleId );

    const [ showNewReport, setShowNewReportModal ] = useState( false );

    const handleNewReport = function () {
        setShowNewReportModal( true );
    }

    const handleNewReportClose = function () {
        setShowNewReportModal( false );
    }

    const history = useHistory();

    const handleOnGo = function ( data ) {
        // console.log( "handleOnGo called with data: " + JSON.stringify( data ) );
        setShowNewReportModal( false );

        if ( isCampaignDisclosuresReport( data.dataset.descriptiveName ) ) {
                openCampaignModal( data );
                return false;
            } else {

        history.push( {
            pathname: "/" + moduleId + PAGE_ROUTES.REPORTS + "/New Report",
            data: data
        } );
        }
    }

    const handleCampaignDateSelection = function ( startDate, endDate ) {
            // Format date as yyyy-MM-dd HH:mm:ss for the API
            const formatDateTimeForAPI = (date) => {
                const pad = (n) => n.toString().padStart(2, '0');
                return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
            };
    
            const startDateStr = formatDateTimeForAPI(startDate);
            const endDateStr = formatDateTimeForAPI(endDate);
    
            // Navigate to the report with the data object similar to the Link component
            history.push({
                pathname: `/${moduleId}${PAGE_ROUTES.REPORTS}/New Report`,
                data: campaignModalState.selectedReport,
                startDate: startDateStr,
                endDate: endDateStr
            });
    
            closeCampaignModal();
        };
    
        const isCampaignDisclosuresReport = function ( reportName ) {
            if (!reportName) return false;
            const lower = reportName.toLowerCase();
            return lower.includes("coi disclosee not started disclosure") || lower.includes("coi disclosee started disclosure");
        };

    return (
        <div className="Reports">
            <div className="header">
                <div className="reportName">Saved Reports</div>
                <div className="buttons">
                    <Button primary onClick={handleNewReport}><Icon name='plus'></Icon>New Report</Button>
                </div>
            </div>

            <div className="contents">
                <div className="anotherDiv">
                </div>

                <ReportsList moduleId={moduleId} />

            </div>

            { showNewReport &&
                <NewReportModal open={showNewReport} onClose={handleNewReportClose} onGo={handleOnGo}/>
            }

            {campaignModalState.showModal && <CampaignDisclosureDateModal
                open={campaignModalState.showModal}
                onCancel={closeCampaignModal}
                onContinue={handleCampaignDateSelection}
                title={
                    campaignModalState.selectedReport &&
                    campaignModalState.selectedReport.dataset?.descriptiveName &&
                    campaignModalState.selectedReport.dataset?.descriptiveName.toLowerCase().includes("not started")
                    ? "Campaign Disclosures - Not Started"
                    : "Campaign Disclosures - Started"
                }
            />}

        </div> );
}

export default Reports;
